// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserMarkerPopup_tabs-container__gePlh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.UserMarkerPopup_user-popup-content__D1ruv {
  font-family: var(--hand-font);
  padding-bottom: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_description__sQJtj {
  text-align: center;
  margin: 15px;
  margin-bottom: 5px;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd {
  max-width: 250px;
  min-width: 220px;
  width: 100%;
  padding: 0;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd a {
  text-decoration: none;
  color: inherit;
  display: grid;
  grid-template-columns: 60px auto;
  padding: 10px;
  background-color: rgb(250, 250, 250);
  font-weight: normal;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd a:hover {
  background-color: rgb(230, 230, 230);
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd a .UserMarkerPopup_basic-details__tiuA7 {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd a .UserMarkerPopup_basic-details__tiuA7 h5,
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd a .UserMarkerPopup_basic-details__tiuA7 p {
  margin: 2px 0;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd a .UserMarkerPopup_basic-details__tiuA7 h5 {
  font-weight: 600;
  font-size: 1.4em;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd a .UserMarkerPopup_basic-details__tiuA7 p {
  font-size: 0.9em;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd.UserMarkerPopup_vertical__bl5zg {
  width: -moz-fit-content;
  width: fit-content;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd.UserMarkerPopup_vertical__bl5zg a {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd.UserMarkerPopup_vertical__bl5zg a:hover {
  background-color: transparent;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd.UserMarkerPopup_vertical__bl5zg a .UserMarkerPopup_basic-details__tiuA7 {
  margin-left: 0;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd.UserMarkerPopup_vertical__bl5zg a .UserMarkerPopup_basic-details__tiuA7 h5,
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_popup-heading__vqApd.UserMarkerPopup_vertical__bl5zg a .UserMarkerPopup_basic-details__tiuA7 p {
  text-align: center;
}
.UserMarkerPopup_user-popup-content__D1ruv .UserMarkerPopup_user-popup-image__YWjLM {
  background-position: center;
  background-size: cover;
  height: 250px;
  width: 250px;
}
@media screen and (max-height: 600px) {
  .UserMarkerPopup_user-popup-content__D1ruv.UserMarkerPopup_adding-object__Yaynw .UserMarkerPopup_description__sQJtj,
  .UserMarkerPopup_user-popup-content__D1ruv.UserMarkerPopup_adding-object__Yaynw .UserMarkerPopup_popup-heading__vqApd, .UserMarkerPopup_user-popup-content__D1ruv.UserMarkerPopup_adding-skill__c-DHQ .UserMarkerPopup_description__sQJtj,
  .UserMarkerPopup_user-popup-content__D1ruv.UserMarkerPopup_adding-skill__c-DHQ .UserMarkerPopup_popup-heading__vqApd {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/UserMarker/UserMarkerPopup/UserMarkerPopup.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACJ;;AAIA;EACI,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;AADJ;AAGI;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;AADR;AAII;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AAFR;AAIQ;EACI,qBAAA;EACA,cAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;AAFZ;AAKY;EACI,oCAAA;AAHhB;AAMY;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAJhB;AAMgB;;EAEI,aAAA;AAJpB;AAOgB;EACI,gBAAA;EACA,gBAAA;AALpB;AAQgB;EACI,gBAAA;AANpB;AAaI;EACI,uBAAA;EAAA,kBAAA;AAXR;AAaQ;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;AAXZ;AAcY;EACI,6BAAA;AAZhB;AAeY;EACI,cAAA;AAbhB;AAegB;;EAEI,kBAAA;AAbpB;AAyBI;EACI,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AAvBR;AA0BI;EAKQ;;;IAEI,aAAA;EA3Bd;AACF","sourcesContent":[".tabs-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 20px;\n    // background-color: #f7f7f7;\n  }\n  \n\n.user-popup-content {\n    font-family: var(--hand-font);\n    padding-bottom: 5px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n\n    .description {\n        text-align: center;\n        margin: 15px;\n        margin-bottom: 5px;\n    }\n\n    .popup-heading {\n        max-width: 250px;\n        min-width: 220px;\n        width: 100%;\n        padding: 0;\n\n        a {\n            text-decoration: none;\n            color: inherit;\n            display: grid;\n            grid-template-columns: 60px auto;\n            padding: 10px;\n            background-color: rgb(250, 250, 250);\n            font-weight: normal;\n\n\n            &:hover {\n                background-color: rgb(230, 230, 230);\n            }\n\n            .basic-details {\n                margin-left: 10px;\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n\n                h5,\n                p {\n                    margin: 2px 0;\n                }\n\n                h5 {\n                    font-weight: 600;\n                    font-size: 1.4em;\n                }\n\n                p {\n                    font-size: 0.9em;\n                }\n            }\n\n        }\n    }\n\n    .popup-heading.vertical {\n        width: fit-content;\n\n        a {\n            padding: 0;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            background-color: transparent;\n\n\n            &:hover {\n                background-color: transparent;\n            }\n\n            .basic-details {\n                margin-left: 0;\n\n                h5,\n                p {\n                    text-align: center;\n                }\n\n                h5 {}\n\n                p {}\n            }\n\n        }\n\n    }\n\n    .user-popup-image {\n        background-position: center;\n        background-size: cover;\n        height: 250px;\n        width: 250px;\n    }\n\n    @media screen and (max-height: 600px) {\n\n        &.adding-object,\n        &.adding-skill {\n\n            .description,\n            .popup-heading {\n                display: none;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs-container": `UserMarkerPopup_tabs-container__gePlh`,
	"user-popup-content": `UserMarkerPopup_user-popup-content__D1ruv`,
	"description": `UserMarkerPopup_description__sQJtj`,
	"popup-heading": `UserMarkerPopup_popup-heading__vqApd`,
	"basic-details": `UserMarkerPopup_basic-details__tiuA7`,
	"vertical": `UserMarkerPopup_vertical__bl5zg`,
	"user-popup-image": `UserMarkerPopup_user-popup-image__YWjLM`,
	"adding-object": `UserMarkerPopup_adding-object__Yaynw`,
	"adding-skill": `UserMarkerPopup_adding-skill__c-DHQ`
};
export default ___CSS_LOADER_EXPORT___;
